module.exports = __webpack_public_path__ + "d16c1591b497f2d24b77f9bce0c9386f.svg";